"use client"

import { useState } from "react"
import { DoneIcon } from "../../../icons"
import { Button } from "@/components/atoms"
import { useTranslate, useTolgee } from "@tolgee/react"
import { T } from "@tolgee/react";
import {sendResetPasswordEmail} from "@/lib/data/customer"

export default function ResetPasswordForm() {
  const [email, setEmail] = useState("")
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState("")
  const { t } = useTranslate()
  const tolgee = useTolgee(["language"])


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")
    setSuccess(false)

    try {
      const res:any = await sendResetPasswordEmail(email, tolgee.getLanguage() ?? "en")
      if (!res.success) {
        throw res
      }

      setSuccess(true)
    } catch (err: any) {
      setError(err.message || err.error || "Something went wrong")
    }
  }

  if (success) {
    return (

      <div className="flex flex-col items-center justify-center rounded-lg bg-green-50 p-4 text-center">
        <DoneIcon size={48} className="mb-2 text-green-600" />
        <p 
          className="text-lg font-medium text-green-800"
          dangerouslySetInnerHTML={{
            __html: t('forgot_password.success_message', {
              email: `<strong class="font-bold">${email}</strong>`
            })
          }}
        />
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-2xl font-semibold mb-4 text-center">{t('forgot_password.title')}</h2>
      <p className="text-gray-600 mb-6 text-center">
        {t('forgot_password.description')}
      </p>
      <input
        type="email"
        required
        className="w-full border px-3 py-2 rounded"
        placeholder={t('forgot_password.email_placeholder')}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Button className="w-full">
        {t('forgot_password.button')}
      </Button>
      {error && (
        <p className="text-red-500 text-sm text-center">{error}</p>
      )}
    </form>
  )
}
